import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'stores-config',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./StoresConfig').default
      callback(null, component)
    }, 'StoresConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/StoresConfig/index.js